/**
 * Pre-compiled localized messages for MoneyInput component
 *
 * Generated by scripts/generate-dictionaries.ts
 * DO NOT EDIT MANUALLY
 *
 * @see https://react-spectrum.adobe.com/react-aria/internationalization.html
 */

import {
  type LocalizedString,
  type LocalizedStrings,
} from "@internationalized/string";
import { normalizeMessages } from "../../utils/normalize-messages";

// Pre-compiled message functions
import moneyInputMessages_en from "./intl/en";
import moneyInputMessages_de from "./intl/de";
import moneyInputMessages_es from "./intl/es";
import moneyInputMessages_fr from "./intl/fr-FR";
import moneyInputMessages_pt from "./intl/pt-BR";

// Raw LocalizedStrings object for use with useLocalizedStringFormatter hook
export const moneyInputMessagesStrings: LocalizedStrings<
  string,
  LocalizedString
> = {
  en: normalizeMessages(moneyInputMessages_en),
  de: normalizeMessages(moneyInputMessages_de),
  es: normalizeMessages(moneyInputMessages_es),
  "fr-FR": normalizeMessages(moneyInputMessages_fr),
  "pt-BR": normalizeMessages(moneyInputMessages_pt),
} as LocalizedStrings<string, LocalizedString>;

/**
 * Available message keys for MoneyInput component
 */
export type MoneyInputMessageKey =
  | "amountInputLabel"
  | "currencySelectLabel"
  | "highPrecisionPrice";
